    <div class="client-create">
      <div class="page-header">
        <button mat-icon-button routerLink="/clients" aria-label="Назад">
          <mat-icon>arrow_back</mat-icon>
        </button>
        <h1 class="page-title">Новый клиент</h1>
      </div>

      <form [formGroup]="form" (ngSubmit)="onSubmit()" class="client-form">
        <mat-card class="form-card">
          <mat-card-content>
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Фамилия</mat-label>
              <input matInput formControlName="lastName" required>
              <mat-error *ngIf="form.get('lastName')?.hasError('required')">Укажите фамилию</mat-error>
              <mat-error *ngIf="form.get('lastName')?.hasError('serverError')">{{form.get('lastName')?.getError('serverError')}}</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Имя</mat-label>
              <input matInput formControlName="firstName" required>
              <mat-error *ngIf="form.get('firstName')?.hasError('required')">Укажите имя</mat-error>
              <mat-error *ngIf="form.get('firstName')?.hasError('serverError')">{{form.get('firstName')?.getError('serverError')}}</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Отчество</mat-label>
              <input matInput formControlName="middleName">
              <mat-error *ngIf="form.get('middleName')?.hasError('serverError')">{{form.get('middleName')?.getError('serverError')}}</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Телефон</mat-label>
              <input matInput formControlName="phone" required
                     mask="0 (000) 000-00-00"
                     [showMaskTyped]="true"
                     placeholder="+7 (___) ___-__-__">
              <mat-error *ngIf="form.get('phone')?.hasError('required')">Укажите телефон</mat-error>
              <mat-error *ngIf="form.get('phone')?.hasError('mask')">Введите полный номер телефона</mat-error>
              <mat-error *ngIf="form.get('phone')?.hasError('serverError')">{{form.get('phone')?.getError('serverError')}}</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Email</mat-label>
              <input matInput formControlName="email" type="email">
              <mat-error *ngIf="form.get('email')?.hasError('serverError')">{{form.get('email')?.getError('serverError')}}</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Номер ВУ</mat-label>
              <input matInput formControlName="driverLicense">
              <mat-error *ngIf="form.get('driverLicense')?.hasError('serverError')">{{form.get('driverLicense')?.getError('serverError')}}</mat-error>
            </mat-form-field>

            <app-date-input formControlName="driverLicenseDate" label="Дата выдачи ВУ"></app-date-input>

            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Серия/номер паспорта</mat-label>
              <input matInput formControlName="passportNumber">
              <mat-error *ngIf="form.get('passportNumber')?.hasError('serverError')">{{form.get('passportNumber')?.getError('serverError')}}</mat-error>
            </mat-form-field>

            <app-date-input formControlName="passportIssuedDate" label="Дата выдачи паспорта"></app-date-input>

            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Кем выдан паспорт</mat-label>
              <input matInput formControlName="passportIssuedBy">
              <mat-error *ngIf="form.get('passportIssuedBy')?.hasError('serverError')">{{form.get('passportIssuedBy')?.getError('serverError')}}</mat-error>
            </mat-form-field>

            <app-date-input formControlName="birthDate" label="Дата рождения"></app-date-input>

            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Заметки</mat-label>
              <textarea matInput formControlName="notes" rows="3"></textarea>
              <mat-error *ngIf="form.get('notes')?.hasError('serverError')">{{form.get('notes')?.getError('serverError')}}</mat-error>
            </mat-form-field>
          </mat-card-content>
        </mat-card>

        <button mat-raised-button color="primary" type="submit" class="full-width-btn"
                [disabled]="form.invalid || submitting">
          <mat-spinner *ngIf="submitting" diameter="20"></mat-spinner>
          <span *ngIf="!submitting"><mat-icon>person_add</mat-icon> Создать клиента</span>
        </button>
      </form>
    </div>
  
